import { render, staticRenderFns } from "./noVertical.vue?vue&type=template&id=134bde7a&scoped=true&"
import script from "./noVertical.vue?vue&type=script&lang=ts&"
export * from "./noVertical.vue?vue&type=script&lang=ts&"
import style0 from "./noVertical.vue?vue&type=style&index=0&id=134bde7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134bde7a",
  null
  
)

export default component.exports